import { render, staticRenderFns } from "./UtilizationTable.vue?vue&type=template&id=3680a10d&scoped=true&lang=pug"
import script from "./UtilizationTable.vue?vue&type=script&lang=js"
export * from "./UtilizationTable.vue?vue&type=script&lang=js"
import style0 from "./UtilizationTable.vue?vue&type=style&index=0&id=3680a10d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680a10d",
  null
  
)

export default component.exports